import React from 'react';
import _ from 'lodash';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';


export const BlogPostBasicInfoComponent = ({
  selectedSocialProfiles,
  handleInnerFormChange,
  helpTopics,
  selectedBlogPosts

}: any) => {


  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Title"
              labelField="Title"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Title'
                );
              }}
              type="text"
              value={selectedBlogPosts?.Title}
            />
            <InputContainer
              label="Caption"
              labelField="Caption"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Caption'
                );
              }}

              type="text"
              value={selectedBlogPosts?.Caption}
            />
            <InputContainer
              label="MetaKeywords"
              labelField="MetaKeywords"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MetaKeywords'
                );
              }}

              type="text"
              value={selectedBlogPosts?.MetaKeywords}
            />
            <InputContainer
              label="MetaDescription"
              labelField="MetaDescription"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MetaDescription'
                );
              }}

              type="text"
              value={selectedBlogPosts?.MetaDescription}
            />
            <InputContainer
              label="MetaTitle"
              labelField="MetaTitle"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MetaTitle'
                );
              }}

              type="text"
              value={selectedBlogPosts?.MetaTitle}
            />
            <InputContainer
              label="BlogShow Start Date"
              labelField="BlogShowStartDateUtc"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'BlogShowStartDateUtc'
                );
              }}
              type="date"
              value={selectedBlogPosts?.BlogShowStartDateUtc}
            />
            <InputContainer
              label="BlogShow End Date"
              labelField="BlogShowEndDateUtc"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'BlogShowEndDateUtc'
                );
              }}
              type="date"
              value={selectedBlogPosts?.BlogShowEndDateUtc}
            />
            <InputContainer
              label="Comments Allowed"
              labelField="IsCommentsAllowed"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event,
                  'IsCommentsAllowed'
                );
              }}
              type="checkbox"
              value={selectedBlogPosts?.IsCommentsAllowed}
            />
            <InputContainer
              label="Limited To Stores"
              labelField="IsLimitedToStores"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event,
                  'IsLimitedToStores'
                );
              }}
              type="checkbox"
              value={selectedBlogPosts?.IsLimitedToStores}
            />
            <div className='col-span-full'>
              <InputContainer
                label="Body"
                name="Body"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'Body'
                  )
                }}
                type="text"
                value={selectedBlogPosts?.Body}
              /></div>
          </div>
        }
        expandedPanel="BasicInfo"
        headerTitle="Basic Info"
      />
    </>
  );
};
export default BlogPostBasicInfoComponent;
